<template>
    <!-- new layout -->
    <div class="p-grid">
        <div class="p-col-12">
            <div class="p-grid">
                <div class="p-col-12">
                    <div v-if="runningUpdate" class="loading__overlay">
                        <i class="pi pi-spin pi-spinner loader" style="font-size: 4rem"></i>
                    </div>
                    <Message v-for="(error, index) of uploadError" severity="error" :key="error" v-if="index < 4">
                        {{ error }}
                    </Message>
                    <Message severity="error" v-if="(uploadError.length > 3)">
                        Total Errors: {{ uploadError.length }}
                    </Message>
                    <FileUpload @select="uploaderLoading = true, handleFileUploadCSV($event)" name="uploadCSV" :customUpload="true" ref="uploader" :fileLimit=1 :showUploadButton="(!uploadError.length && uploadReady == true) ? true : false" @clear="uploadError = [], uploadReady = false" @remove="uploadError = [], uploadReady = false" @uploader="startUploadCSV()" accept=".csv" :maxFileSize="1000000" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { db, storage } from '@/firebase';
import { mapGetters } from "vuex";
import axios from 'axios';

export default {
    data() {
        return {
            content: [],
            files: [],
            CSVresult: [],
            uploadError: [],
            uploadReady: false,
            uploaderLoading: false,
            runningUpdate: false,
            assetKeys: [],
            batchKeys: [],
        }
    },
    firestore() {
        return {
            // importer_files: db.collection('importer_files'),
            client: db.collection('clients').doc(this.$route.params.client_id),
            sites: db.collection('sites').where('client_id', '==', this.$route.params.client_id),
            // assets: db.collection('assets'),
        }
    },
    computed: {
        ...mapGetters({
            user: "user"
        }),
    },
    methods: {
        handleFileUploadCSV() {
            this.uploaderLoading = true;
            this.uploadReady = false;

            const UploadHandlerUrl = process.env.VUE_APP_API_URL + '/upload-handler';

            axios({
                method: 'post',
                url: UploadHandlerUrl,
                headers: {
                    'Authorization': `Bearer ${this.user.auth.accessToken}`
                },
                data: {
                    'siteId': this.$route.params.id
                }
            }).then((response) => {

                this.batchKeys = response.data.batches;
                this.assetKeys = response.data.assets;

                var reader = new FileReader();
                reader.onload = this.onReaderLoad; // triggers the onReaderLoad() function
                reader.readAsText(this.$refs.uploader.files[0])
            }).catch(error => { console.error(error) });
        },
        onReaderLoad(event) {
            // this.uploadError = [];
            const UploadLoaderUrl = process.env.VUE_APP_API_URL + '/upload-loader';

            axios({
                method: 'post',
                url: UploadLoaderUrl,
                headers: {
                    'Authorization': `Bearer ${this.user.auth.accessToken}`
                },
                data: {
                    'fileData': event.target.result,
                    'siteId': this.$route.params.id,
                    'clientId': this.$route.params.client_id,
                    'batchKeys': this.batchKeys,
                    'assetKeys': this.assetKeys
                }
            }).then((response) => {
                if (response.data.error) {
                    this.uploadError = response.data.error;
                } else {
                    this.CSVresult = response.data.result;
                    this.uploadReady = true;
                    this.uploaderLoading = false;
                }
                // this.CSVresult = response.data.result;
            }).catch(error => { console.error(error) });


        },
        startUploadCSV() {

            const UploaderUrl = process.env.VUE_APP_API_URL + '/upload-update';
            this.runningUpdate = true;

            axios({
                method: 'post',
                url: UploaderUrl,
                headers: {
                    'Authorization': `Bearer ${this.user.auth.accessToken}`
                },
                data: {
                    'clientId': this.$route.params.client_id,
                    'CSVresult': this.CSVresult
                }
            }).then((response) => {
                db.collection('logs').add({
                    activity: 'Assets Imported',
                    timestamp: new Date(),
                    user: this.user.data.email,
                    client_id: this.user.data.client.key
                }).then(() => {
                    // Update site statuses after successful import
                    const updateStatusesUrl = process.env.VUE_APP_API_URL + '/maintenance/update-statuses/site';
                    axios({
                        method: 'post',
                        url: updateStatusesUrl,
                        headers: {
                            'Authorization': `Bearer ${this.user.auth.accessToken}`
                        },
                        data: {
                            'siteId': this.$route.params.id
                        }
                    }).then(() => {
                        console.log('Site statuses updated successfully');
                    }).catch(error => {
                        console.error('Failed to update site statuses:', error);
                    });

                    this.$emit('importSuccess');
                    this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Assets Imported', life: 3000 });
                    this.uploadReady = false;
                    this.runningUpdate = false;
                });
                // this.CSVresult = response.data.result;
            }).catch(error => { console.error(error) });

            // this needs to be kept seperate to the above promise
            this.$refs.uploader.files.forEach(file => {
                let uniqueName = Date.now() + '_' + file.name;
                this.convertToBase64(file, base64String => {
                    const storageRef = storage.ref('importer-files/' + uniqueName).putString(base64String, 'data_url');

                    storageRef.on(`state_changed`, snapshot => { }, error => {
                        console.error(error.message)
                    }, () => {
                        storageRef.snapshot.ref.getDownloadURL().then((url) => {
                            const doc = {
                                src: url,
                                type: file.type,
                                name: file.name,
                                uniqueName: uniqueName,
                            }
                            db.collection('importer_files').add({
                                data: doc
                            }).then(() => {
                                this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Uploaded File Stored', life: 3000 });
                            });
                        });
                    });
                });
            });

            this.$refs.uploader.clear();

        },
        convertToBase64(file, cb) {
            // FileReader function for read the file.
            var fileReader = new FileReader();
            var base64;
            // Onload of file read the file content
            fileReader.onload = function (fileLoadedEvent) {
                base64 = fileLoadedEvent.target.result;
                cb(base64);
            };
            // Convert data to base64
            fileReader.readAsDataURL(file);
        },
    }
}
</script>

<style>
.loading__overlay {
    position: absolute;
    z-index: 2;
    background: #e0e0e0ab;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>